import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const DeleteTextButton = styled.button`
  padding: 0;
  border: none;
  color: ${withVar(DesignToken.ActionNegativeDefault)};
  background-color: transparent;

  &:focus,
  &:active {
    outline: none;
  }
`;
